import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { ConfigService } from '../config/config.service';

@Injectable({
  providedIn: 'root'
})
export class AfericaoOperacionalService {
 private baseUrl: string;

  constructor(private http: HttpClient, private configService: ConfigService) {
    this.baseUrl = this.configService.pessoaApi;
  }
  getAfericaoOperacionais(
    pageSize: number = 10,
    pageIndex: any,
    sortDirection: any,
    sortProperty: any,
    filterText: string,
    filterData: any,
    statusFilter: any
  ) {
    let params = new HttpParams()
      .set('page', pageIndex?.toString() || '0')
      .set('size', pageSize)
      .set('sortField', sortProperty || '')
      .set('sortDirection', sortDirection || '')
      .set('nomeNumeroContrato',  filterData?.value?.contractName || '')
      .set('nomeRelatorio', filterText || filterData?.value?.nomeRelatorio || '')
      .set('nomeTipoRelatorio', filterData?.value?.nomeTipoRelatorio || '')
      .set('itemContratual', filterData?.value?.itemContratual || '')
      .set('nomeAreaFuncional', filterData?.value?.nomeAreaFuncional || '')
      .set('tipoDataBase', filterData?.value?.tipoDataBase || '')
      .set('dataBase', filterData?.value?.dataBase || '')
      .set('prazo', filterData?.value?.prazo || '')
      .set('mesAnoPrazo', filterData?.value?.mesAnoPrazo || '')
      .set('dataAfericao', filterData?.value?.dataAfericao || '')
      .set('statusAtuais', filterData?.value?.statusAtuais || '')

    if (filterData?.value?.prazoInicio) {
      params = params.set('prazoInicio', moment(filterData?.value?.prazoInicio).format('YYYY-MM-DD') || '')
    }
    if (filterData?.value?.prazoFim) {
      params = params.set('prazoFim', moment(filterData?.value?.prazoFim).format('YYYY-MM-DD') || '')
    }
    if (filterData?.value?.dataAfericaoInicio) {
      params = params.set('dataAfericaoInicio', moment(filterData?.value?.dataAfericaoInicio).format('YYYY-MM-DD') || '')
    }
    if (filterData?.value?.dataAfericaoFim) {
      params = params.set('dataAfericaoFim', moment(filterData?.value?.dataAfericaoFim).format('YYYY-MM-DD') || '')
    }
    if (statusFilter && statusFilter != 'Todos') {
      statusFilter.forEach((status: any) => params = params.append('statusAtuais', status.label || status.descricao))
    }
     if (filterData?.value?.situacaoPrazo) {
      params = params.set('situacaoPrazo' ,filterData?.value?.situacaoPrazo || '')
    }


    return this.http.get(this.baseUrl + `/v1/afericoes/relatorios-operacionais`, { params });
  }

  getAfericaoOperacional(idRelatorioContratual: string) {
    return this.http.get(this.baseUrl + `/v1/afericoes/relatorios-operacionais/${idRelatorioContratual}`);
  }
  getTipoAnalises() {
    return this.http.get(
      this.baseUrl +
      `/v1/tipos-analise?page=0&size=10&sortDirection=asc&sortField=id&nome=Realizar avaliação documental&descricao=`
    );
  }

  postTransicaoStatus(formData: FormData) {
    return this.http.post(this.baseUrl + `/v1/afericoes/relatorios-operacionais/processar-status`, formData);
  }
  postTransicaoStatusAnalise(idParametroServicoInicial: string, formData: any) {
    return this.http.post(this.baseUrl + `/v1/afericoes/relatorios-operacionais/${idParametroServicoInicial}/analises/processar-status`, formData);
  }
  getProtocolos(idParametroServicoInicial: string) {
    return this.http.get(
      this.baseUrl +
      `/v1/afericoes/relatorios-operacionais/${idParametroServicoInicial}/documentos/protocolos`
    );
  }
 getDocumentosAssinados(
    pageSize: number = 10,
    pageIndex: any,
    sortDirection: any,
    sortProperty: any,
    idParametroServicoInicial: string
  ) {
    let params = new HttpParams()
      .set('page', pageIndex?.toString() || '0')
      .set('size', pageSize)
      .set('sortField', sortProperty || '')
      .set('sortDirection', sortDirection || '')
    return this.http.get(
      this.baseUrl +
      `/v1/afericoes/relatorios-operacionais/${idParametroServicoInicial}/documentos/assinados`
      , { params }
    );
  }
  getDocumentosComprovacao(
    idParametroServicoInicial: string,
    idDocumentoComprovacao: string,
  ) {
    return this.http.get(
      this.baseUrl +
      `/v1/afericoes/relatorios-operacionais/${idParametroServicoInicial}/documentos/${idDocumentoComprovacao}`
    );
  }
  getDocumentosPendentes(
    pageSize: number = 10,
    pageIndex: any,
    sortDirection: any,
    sortProperty: any,
    idParametroServicoInicial: string
  ) {
    let params = new HttpParams()
      .set('page', pageIndex?.toString() || '0')
      .set('size', pageSize)
      .set('sortField', sortProperty || '')
      .set('sortDirection', sortDirection || '')
    return this.http.get(
      this.baseUrl +
      `/v1/afericoes/relatorios-operacionais/${idParametroServicoInicial}/documentos/assinaturas-pendentes`
      , { params }
    );
  }
  assinarDocumento(idParametroServicoInicial: any, idUsuarioAssinante: any,) {
    const data = {
      idUsuarioAssinante: idUsuarioAssinante
    }
    return this.http.post(`${this.baseUrl}/v1/afericoes/relatorios-operacionais/${idParametroServicoInicial}/documentos/assinar`, data)
  }
  deleteAssinaturaPendente(idParametroServicoInicial: any, idDocumentoComprovacao: any) {
    return this.http.delete(`${this.baseUrl}/v1/afericoes/relatorios-operacionais/${idParametroServicoInicial}/documentos/${idDocumentoComprovacao}`,)
  }
    getDetalhesItemAnalise(idParametroServicoInicial: string, idItemAnalise: string) {
    return this.http.get(
      this.baseUrl +
      `/v1/afericoes/relatorios-operacionais/${idParametroServicoInicial}/analises/documentos/${idItemAnalise}`
    );
  }
    getAnaliseAfericoes(
    pageSize: number = 10,
    pageIndex: any,
    sortDirection: any,
    sortProperty: any,
    idParametroServicoInicial: string
  ) {
    let params = new HttpParams()
      .set('page', pageIndex?.toString() || '0')
      .set('size', pageSize)
      .set('sortField', sortProperty || '')
      .set('sortDirection', sortDirection || '')
    return this.http.get(
      this.baseUrl +
      `/v1/afericoes/relatorios-operacionais/${idParametroServicoInicial}/analises`
      , { params }
    );
  }

   getFilterOptions(){
     return this.http.get(
      this.baseUrl + `/v1/afericoes/relatorios-operacionais/filtros-status`
    );
  }
}
